<template>
  <div>
    <vx-card style="margin-bottom: 15px">
      <b-row>
        <b-col lg="6" sm="6">
          <b-row>
            <b-col>
              <b-form-input
               
                v-model="arananDeger"
                @keyup.enter="varyantliStokList"
                id="smallInput"
                placeholder="Arama..."
              />
              
            </b-col>
            <b-col>
              <b-button
                
                v-on:click="varyantliStokList()"
                variant="primary"
                >Listele
              </b-button>
              
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="3"> </b-col>
        <b-col lg="3" sm="3" align-v="center" align-self="center">
          <label style="    margin-right: 10px;">
            <vs-radio v-on:change="externalFilterChanged('everyone')" vs-name="radios1" vs-value="luis">Tümü</vs-radio>
          </label>
  
          <label style="    margin-right: 10px;">
            <vs-radio v-on:change="externalFilterChanged('sonuc')" vs-name="radios1" vs-value="luis">Resmi olamayanlar</vs-radio>
          </label>
           
        </b-col>
        <b-col lg="1" sm="1"> </b-col>
      </b-row>
    </vx-card>

    <ag-grid-vue
      style="width: 100%; height: 750px"
      class="ag-theme-alpine"
      :animateRows="true"
      :suppressCopyRowsToClipboard="true"
      :defaultColDef="defaultColDef"
      :columnDefs="productListColumn"
      :rowData="productListVaryant"
      :localeText="localeText"
      :pagination="true"
      :rowSelection="'single'"
      @grid-ready="onGridReady"
      :isExternalFilterPresent="isExternalFilterPresent" :doesExternalFilterPass="doesExternalFilterPass"
    >
    </ag-grid-vue> 
    <vs-prompt
      title="Dosya Ekle"
      acceptText="Ekle"
      cancelText="Vazgeç"
      @accept="resimEkle"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        <b-row style="margin-top: 20px">
          <span>Resim Ekle</span>
          <vs-divider color="Default"> </vs-divider>
          <div class="centerx">
            <!--  <vs-upload
              style="padding: 0"
              automatic
              action="https://jsonplaceholder.typicode.com/posts/"
              @change="onFileChange"
            />-->
            <input type="file" accept="image/*" @change="onFileChange" id="file-input" />
          </div>
        </b-row>
      </div>
    </vs-prompt>
    <vs-prompt
      title="Dosya Ekle"
      acceptText="Sil"
      cancelText="Vazgeç"
      @accept="resimSil"
      :active.sync="removePrompt"
    >
      <div class="con-exemple-prompt">
        <b-row style="margin-top: 20px">
          <span>Resim Sil</span>
          <vs-divider color="Default"> </vs-divider>
          <div class="centerx">
            {{ pictureBarcode }} barkodlu resmi silmek istefiğinize emin misiniz?
          </div>
        </b-row>
      </div>
    </vs-prompt>
    <b-modal
      ref="modal-resim"
      id="modal-primary"
      modal-class="modal-primary"
      size="sm"
      centered
      title="BootstrapVue"
      hide-footer
      hide-header
    >
      <img :src="imageLink" style="width: 100%" />
    </b-modal>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { BFormCheckbox } from "bootstrap-vue";
import Store from "../../store/store";
import state from "../../store/state";
import userJson from "../../../public/user.json";
import ProductListStokResim from "../products/CellRenderer/ProductListStokResim.vue";
import TextGorunumCellRenderer from "./CellRenderer/TextGorunumCellRenderer";
import StockPicturesActions from "./CellRenderer/StockPicturesActions.vue"
export default {
  data() {
    return {
      localeText: null,
      ageType: "everyone",
      productListColumn: [],
      productListVaryant: [],
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      imageLink: "",
      varyantlimi: userJson.varyant,
      pictureState: false,
      arananDeger: "",
      activePrompt: false,
      removePrompt: false,
      dir: false,
      sistemurl: "",
      pageLength: 50,
      secilenStok: [],
      checkSelected: [],
      stockList: [],
      currentGelenPage: 1,
      pictureBarcode: "",
 
    };
  },
  methods: {
    doesExternalFilterPass(node) {
      if (node.data) {
        switch (this.ageType) {
          case "sonuc":
            return node.data.image == "" || node.data.image == "null" || node.data.image == null;

 
          default:
            return true;
        }
      }
      return true;
    },
    isExternalFilterPresent() {
      // if ageType is not everyone, then we are filtering
      return this.ageType !== "everyone";
    },
    externalFilterChanged(newValue) {
      this.ageType = newValue;
      this.gridApi.onFilterChanged();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onClick(event) {
      // alert("lalalala"+event)
      this.imageLink = this.sistemurl + event;
      this.$refs["modal-resim"].show();
    },
    resimSil() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");

      const args = {
        f: "",
        stokKodu: this.pictureBarcode, // this.pictureBarcode,
        barkod: "",
        fileName: "",
      };
      soap.createClient(url, function (err, client) {
        client.B2B_uploadFileProduct(args, function (err, result) { 
            vm.varyantliStokList();
          
        });
      });
    },
    pictureRemove(barkod, stokkod) {
      this.removePrompt = true;

      if (this.varyantlimi == "true") {
        this.pictureBarcode = barkod;
      } else this.pictureBarcode = stokkod;
    },
    changeState() {
       
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;

        vm.upload(e.target.result, file.name);
      };
      reader.readAsDataURL(file);
    },
    upload(f, fileName) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");
      var letters = {
        İ: "I",
        I: "I",
        Ş: "S",
        Ğ: "G",
        Ü: "U",
        Ö: "O",
        Ç: "C",
        ı: "i",
        ş: "s",
        ğ: "g",
        ü: "u",
        ö: "o",
        ç: "c",
      };
      var args = {
        f: f,
        stokKodu: this.pictureBarcode, // this.pictureBarcode,
        barkod: "",
        fileName: fileName.replace(/(([İIŞĞÜÇÖışğüöç]))/g, function (letter) {
          return letters[letter];
        }),
      };

      soap.createClient(url, function (err, client) {
        client.B2B_uploadFileProduct(args, function (err, result) { 
            vm.varyantliStokList();
           
        });
      });
    },
    trKarakter() {
      var string = this;
      var letters = { İ: "i", I: "ı", Ş: "ş", Ğ: "ğ", Ü: "ü", Ö: "ö", Ç: "ç" };
      string = string.replace(/(([İIŞĞÜÇÖ]))/g, function (letter) {
        return letters[letter];
      });
      return string.toLowerCase();
    },
    resimEkle() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      /*  this.pictureBarcode = this;
      
      string = string.replace(/(([İIŞĞÜÇÖ]))/g, function (letter) {
        return letters[letter];
      });*/
      var letters = { İ: "I", I: "I", Ş: "S", Ğ: "G", Ü: "U", Ö: "O", Ç: "C" };

      const args = {
        stokKodu: this.pictureBarcode, // this.pictureBarcode
        barkod: "",
      };
      soap.createClient(url, function (err, client) {
        client.B2B_klasorResimleri(args, function (err, result) {
          vm.varyantliStokList();
        });
      });
      vm.varyantliStokList();
    },
    stockDetail(barkod, stokkod) {
      this.activePrompt = true;
      if (this.varyantlimi == "true") {
        this.pictureBarcode = barkod;
      } else this.pictureBarcode = stokkod;
    },
    selectionChanged(params) {
      this.secilenStok = params.selectedRows;
    },
 
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    generateColumnDefs(rowData, columnDefs) {
      // İlk veri satırını kontrol ederek boş sütunları belirle
      if (rowData.length > 0) {
        this.productListColumn = Object.keys(rowData[0])
          .map((key) => {
            const isEmpty = rowData.every(
              (row) =>
                row[key] === "" ||
                row[key] === 0 ||
                row[key] == null ||
                key == "barcode" ||
                key == "KAYITSAYISI" ||
                key == "images" ||
                key == "page" ||
                key == "count" ||
                key == "image"
            );

            return isEmpty
              ? null
              : {
                  headerName: this.$t(key),
                  field: key,
                  filter: "agSetColumnFilter",
                  wrapText: true,
                  autoHeight: true,
                  cellRenderer: "TextGorunumCellRenderer",
                };
          })
          .filter((colDef) => colDef !== null);
      }
    },
    varyantliStokListDispatch() {
      let args = {
        ARANAN: "",
        ACTID: this.customerId,
        userPriceType: this.userPriceType,
        priceType: userJson.priceType,
      };
      this.$store.dispatch("getDataStockVaryant", args).then((response) => {
        if (response == "-1") {
        } else {
        }
      });
    },
    varyantliStokList(val) {
      var vm = this;
      vm.productListVaryant = vm.stocksVaryant; 

      if (vm.arananDeger != "" && vm.arananDeger != "Tümü") {
        vm.productListVaryant = vm.productListVaryant.filter((post) => {
          return (
            post.stockCode.toUpperCase().includes(vm.arananDeger.toUpperCase()) ||
            post.stockName.toUpperCase().includes(vm.arananDeger.toUpperCase()) ||
            post.barcode.toUpperCase().includes(vm.arananDeger.toUpperCase())
          );
        });
      } else vm.productListVaryant = vm.stocksVaryant;
      let columnList = Object.keys(vm.productListVaryant[0]);
      vm.productListColumn = [];
      vm.generateColumnDefs(vm.productListVaryant);
      vm.productListColumn.push({
        sortable: true,
        width: 100,
        pinned: "left",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "StockPicturesActions",
        filter: "agSetColumnFilter",
      });
      columnList.forEach((val, index) => {
        if (val == "image") {
          vm.productListColumn.push({
            width: 120,
            headerName: vm.$t(val),
            field: val,
            filter: "agSetColumnFilter",
            wrapText: true,
            autoHeight: true,
            cellClass: "textType",
            cellRenderer: "ProductListStokResim",
            pinned: "left",
          });
        } else if (val == "barcode") {
          vm.productListColumn.push({
            headerName: vm.$t(val),
            field: val,
            filter: "agSetColumnFilter",
            wrapText: true,
            autoHeight: true,
            cellClass: "textType",
            cellRenderer: "TextGorunumCellRenderer",
            pinned: "left",
          });
        }
      });
    },
  },
  watch: {
    customerId(val) {
      return val;
    },
    stocksVaryant(val) { 
      this.varyantliStokList();
      return val;
    },
    userPriceType(val) {
      return val;
    },
  },
  computed: {
    userPriceType: {
      get() {
        return this.$store.state.userPriceType;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    customerId: {
      get() {
        return this.$store.state.UserId;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stocksVaryant: {
      get() {
        return this.$store.state.eCommerce.StockListVaryant;
      },
      set(val) {
        if (!val) {
        }
      },
    },
  },
  components: {
    StockPicturesActions,
    TextGorunumCellRenderer,
    ProductListStokResim,
    AgGridVue,
    BFormCheckbox,
  },
  created() {
    this.sistemurl = Store.state.imgurl;
    this.varyantliStokListDispatch();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("stockDetail", (paramDetail) => {  
      this.stockDetail(paramDetail.barcode, paramDetail.stockCode);
    });
    this.$root.$on("pictureRemove", (paramDetail) => {  
      this.pictureRemove(paramDetail.barcode, paramDetail.stockCode);
    });
  },
  beforeDestroy() {
    this.$root.$off("stockDetail");
    this.$root.$off("pictureRemove");
  },
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
table.vgt-table {
  font-size: small;
}
.con-vs-dialog .vs-dialog {
  max-width: 500px;
}
.view-upload {
  z-index: 52000000000000000000000000000000000000000000000000000000;
}
.con-input-upload {
  width: 100px;
  height: 100px;
}
.con-img-upload .img-upload {
  width: 100px;
  height: 100px;
}
</style>
